module.exports = __webpack_public_path__ + "static/media/ar.c3f97b85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/user/ar.svg
// module id = 546
// module chunks = 1